module.exports = __webpack_public_path__ + "img/shopping-bag.810eb52c.svg";